import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import * as Sentry from '@sentry/browser';

import 'utils/i18n';

import App from 'App';
import { Maintenance } from 'pages/Maintenance';

import { store, persistor } from './store';

import './index.scss';
import {DarkModeProvider} from "./DarkModeProvider";

if (process.env.REACT_APP_SENTRY_DSN) {
	Sentry.init({ dsn: process.env.REACT_APP_SENTRY_DSN });
}

const maintenance = process.env.REACT_APP_MAINTENANCE_MODE === '1';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
	<DarkModeProvider>
		{maintenance ? (
			<Maintenance />
		) : (
			<Provider store={store}>
				<PersistGate persistor={persistor}>
					<App />
				</PersistGate>
			</Provider>
		)}
	</DarkModeProvider>,
);
